<template>
  <div>
    <div class="center-aligner app-footer row" :class="textClass">
      <p :class="textClass" class="footer-text">
        <i aria-hidden="true" style="color:red" class="fa fa-heart mr-1"></i>
        {{ $t("scenes.auth.login.footer.poweredBy") }}
        <a href="https://memento-yearbooks.com" target="_blank">{{
          $t("scenes.auth.login.footer.m_strMementoYearbook")
        }}</a>
        <span class="ml-2">&#9679; </span>
        <a
          href="https://status.yearbooks.me"
          target="_blank"
          class="ml-2 mr-2"
          >{{ $t("scenes.auth.login.footer.status") }}</a
        >
        <template v-if="getSupportUrl">
          <span class="ml-2">&#9679; </span>
          <a :href="getSupportUrl" target="_blank" class="ml-2 mr-2">{{
            $t("scenes.auth.login.footer.help")
          }}</a>
        </template>
      </p>
    </div>

    <div
      class="row app-footer center-aligner"
      style="margin-top: 20px;"
      :class="textClass"
    >
      <p :class="publisherTextClass" style="color: grey">
        <template v-if="getStorefrontPublisherName">
          <el-icon name="shopping-bag-1 mr-2"></el-icon>
          <span v-if="getStorefrontPublisherWebsite"
            >Shop managed by
            <a :href="getStorefrontPublisherWebsite" target="_blank">{{
              getStorefrontPublisherName
            }}</a>
          </span>
          <span v-else> Shop managed by {{ getStorefrontPublisherName }} </span>
          <template v-if="mailToLink">
            <el-icon name="postcard ml-2 mr-2"></el-icon>
            <a :href="mailToLink" v-if="mailToLink">Contact us</a>
          </template>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  props: {
    darkText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getStorefrontContactEmail",
      "getStorefrontPublisherName",
      "getStorefrontPublisherWebsite",
      "getSupportUrl"
    ]),
    textClass() {
      const textClass = this.darkText ? "c-black" : "c-white";
      return textClass;
    },
    publisherTextClass() {
      const textClass = this.getStorefrontPublisherName
        ? "publisher-text active"
        : "publisher-text";
      return textClass;
    },
    mailToLink() {
      let srtMailToLink = null;
      if (this.getStorefrontContactEmail) {
        srtMailToLink = `mailto:${this.getStorefrontContactEmail}`;
      }
      return srtMailToLink;
    }
  }
};
</script>
<style>
@import "../../styles/css/lib/bootstrap/bootstrap-grid.css";
.publisher-text {
  opacity: 0;
  -webkit-transition: all 0.25s cubic-bezier(0.37, 0, 0.45, 0.99);
  transition: all 0.25s cubic-bezier(0.37, 0, 0.45, 0.99);
}
.publisher-text.active {
  opacity: 1;
}
</style>
